import { tracker } from '@jctrans-materials/shared'
import { isClient } from '@vueuse/core'
import { generateClientUid } from '~/utils/auth'

export default defineNuxtPlugin(async (nuxtApp) => {
  if (!isClient) {
    return
  }

  // await callOnce(async () => {
  //   const uid = generateClientUid()
  //   tracker.identify(uid, () => {})
  // })

  let deviceId = ''
  nuxtApp.provide('getFingerprint', async () => {
    tracker.getDeviceId((value) => {
      deviceId = value
    })
    return deviceId
  })
})
